import { render, staticRenderFns } from "./StatisticsDataItem.vue?vue&type=template&id=4a7ae9b2&scoped=true&"
import script from "./StatisticsDataItem.vue?vue&type=script&lang=js&"
export * from "./StatisticsDataItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsDataItem.vue?vue&type=style&index=0&id=4a7ae9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ae9b2",
  null
  
)

export default component.exports